import type { ReactNode } from "react";
import { isLoggedIn, useAuthState } from "../../contexts/AuthProvider.js";

export function Authenticated(
    { children }: { children: ReactNode },
): JSX.Element {
    const auth = useAuthState();
    return <>{isLoggedIn(auth) && children}</>;
}
